import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'component-clinical-experience',
  templateUrl: './clinical-experience.component.html',
  styleUrls: ['./clinical-experience.component.scss','../../../styles.scss']
})
export class ClinicalExperienceComponent implements OnInit {
 public mobile: boolean = true;
  constructor(@Inject(PLATFORM_ID) private platformId:Object) { }
  @HostListener('window:resize', ['$event']) onWindowResize() {
      if(isPlatformBrowser(this.platformId)&&window.innerWidth<968){  
        this.mobile = true;
      }else if(isPlatformBrowser(this.platformId)&&window.innerWidth >968){
        this.mobile = false;
      };
  }
  activateAccordion(arg0: number) {
    throw new Error('Method not implemented.');
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)&& window.innerWidth > 968) { // 768px portrait
      this.mobile = false;      
    }  
  }

}
